// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.branchRegions', {
    url: '/branchregions',
    controller: 'BranchRegionsController as vm',
    templateUrl: 'main/configuration/branchRegions/branchRegions.tpl.html',
    data: { pageTitle: 'Branch Regions' },
  });
};

class BranchRegionsController {
  constructor(currentOrganization) {
    'ngInject';
    this.organization = currentOrganization;
  }
}
angular
  .module('configuration.branchRegions', [])
  .config(config)
  .controller('BranchRegionsController', BranchRegionsController);
